module.exports = __webpack_public_path__ + "img/bankB-icon.8a0d4c96.svg";